import styled from "styled-components";
export const OfflineInvoiceStyle = styled.div`
  .invoice {
    display: flex;
    align-items: center;
    padding: 20px;
    background-color: ${({ theme }) => theme.box};
    &:nth-child(even) {
      background-color: ${({ theme }) => theme.body};
    }
    box-shadow: ${({ theme }) => theme.shadow};
    border-radius: 10px;
    margin-bottom: 20px;
    .status {
      .icon {
        font-size: 52px;
      }
    }
    .main-content {
      padding: 0px 20px;
    }
    .price {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .actions {
      display: flex;

      justify-content: left;
      button {
        margin: 0px 5px;
        height: 30px;
        padding: 0px;
        width: 30px;
        svg {
          margin: 6px;
        }
      }
    }
  }
  @media (max-width: 768px) {
    .invoice {
      .status {
        display: flex;
        align-self: flex-start;
      }
      .main-content {
      }
    }
  }
`;
